module.exports = __webpack_public_path__ + "static/media/slide-8.12112450.jpg";